import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@gasbuddy/react-components';
import EditMembernameStatus, { USERNAME_STATE } from '../EditMembernameStatus';
import { noop } from '../../../lib/utils';

export default function EditMembernameModal({
  error,
  isLoading,
  onCloseModal,
  onFinish,
  onSubmit,
  onReset,
  showModal,
  statusVariant,
  memberName,
}) {
  const [variant, setVariant] = useState(statusVariant);
  const [customName, setCustomName] = useState(memberName);

  const handleSubmit = useCallback((newMemberName) => {
    onSubmit(newMemberName).then((result) => {
      if (result.error) {
        throw result;
      }
      setCustomName(newMemberName);
      setVariant(USERNAME_STATE.UPDATED);
    }).catch(() => {}); // catch is _required_ here or Uncaught Exception is thrown
  }, [onSubmit]);

  return (
    <Modal
      forceIsShowing={showModal}
      size="sm"
      bgClickable={false}
      closeIcon={false}
      onClose={onCloseModal}
    >
      <EditMembernameStatus
        variant={variant}
        onClose={onCloseModal}
        onFinish={onFinish}
        onSubmit={handleSubmit}
        onReset={onReset}
        error={error}
        isLoading={isLoading}
        memberName={customName}
      />
    </Modal>
  );
}

EditMembernameModal.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  memberName: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func,
  onFinish: PropTypes.func,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  showModal: PropTypes.bool,
  statusVariant: PropTypes.number,
};

EditMembernameModal.defaultProps = {
  error: undefined,
  isLoading: false,
  onCloseModal: noop,
  onFinish: noop,
  onSubmit: noop,
  onReset: noop,
  showModal: false,
  statusVariant: USERNAME_STATE.EDITABLE,
};
